import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import Page from 'flow/components/Setting/Page';

import Loading from 'flow/components/ui-components/Loading';
import { useHistory, useParams } from 'react-router-dom';
import { PbxParams } from 'flow/types/Params';
import ConnectionSettings from 'flow/components/pbx/PbxConnectionSettings';
import { routes } from 'flow/types/routes';
import useSinglePaneMode from 'flow/hooks/useSinglePaneMode';

const PbxConnectionSettings = () => {
    const history = useHistory();
    const { isSinglePaneMode } = useSinglePaneMode();
    const { connectionKey } = useParams<PbxParams>();

    const connections = useAppSelector((state) => state.pbx.get('connections'));

    if (!connections || connections.isEmpty()) {
        return <Loading />;
    }
    const connection = connections.find(
        (connection) => connection.get('key') === connectionKey,
    );

    return (
        <Page
            header={connection.get('description')}
            onClickBack={
                isSinglePaneMode ? () => history.push(routes['pbx']) : undefined
            }
        >
            <ConnectionSettings connection={connection} />
        </Page>
    );
};

export default PbxConnectionSettings;
